module.exports = __webpack_public_path__ + "static/media/tolls-image.1e7cfd5f.png";